export const formatNumber = (value) => {
  // Ensure that the value is displayed with trailing zeros only when necessary
  const floatValue = parseFloat(value);
  return floatValue.toFixed(2);
};

export function formatPrice(val, locale = "en-US", currency = "USD", negative = false) {
  const numberValue = typeof val === "number" ? val : parseFloat(val);

  if (isNaN(numberValue)) {
    return new Intl.NumberFormat(locale, {
      style: "currency",
      currency: currency,
    }).format(0);
  }

  const formattedValue = new Intl.NumberFormat(locale, {
    style: "currency",
    currency: currency,
    minimumFractionDigits: 2,
  }).format(Math.abs(numberValue));

  if (negative && Number(val) !== 0) {
    return `(${formattedValue})`;
  }

  return formattedValue;
}

export const priceTransform = (value) => {
  if (isNaN(value)) {
    return null;
  } else {
    const clean = value.replace(/\D/g, '');
    return String(+clean)
      .padStart(3, '0')
      .replace(/(..)$/, '.$1');
  }
};